import { registerUnion } from '@adornis/baseql/metadata/register';
import { Folder } from './Folder';
import type { IMedia } from './IMedia';
import { LASFile } from './LASFile';

export type MediaUnion = (LASFile | Folder) & IMedia;
export const BaseQLMediaUnion = registerUnion({
  types: () => [LASFile, Folder],
  name: 'MediaUnion',
});
